import * as React from 'react';
import { useBootstrapReady } from '@shared/lib/Bootstrap/useBootstrapReady';
import ExternalLocaleResources from '../../../ExternalLocaleResources/ExternalLocaleResources';
export const BootstrapGate = ({ children }) => {
    const ready = useBootstrapReady();
    return (React.createElement(React.Fragment, null,
        React.createElement(ExternalLocaleResources, null),
        ready && children));
};
